import BadgeWarning from '@/components/BadgeWarning';
import BoldText from '@/components/BoldText';
import MediumText from '@/components/MediumText';
import { BREAKPOINT, Touchpoint } from '@/constants/enum';
import { PATH } from '@/constants/path';
import useToast from '@/hooks/useToast';
import useUserPlan from '@/hooks/useUserPlan';
import { apiCaller } from '@/redux/query';
import { isSkipApiSelector } from '@/redux/slice/auth.slice';
import { isLoadingGeneralSettingsSelector } from '@/redux/slice/loading';
import { dataSettingsSelector } from '@/redux/slice/settings.slice';
import { Badge, Button, Card, Icon } from '@shopify/polaris';
import { LocationIcon } from '@shopify/polaris-icons';
import { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { useNavigate } from 'react-router-dom';

function AutoDetectLocation() {
  const navigate = useNavigate();
  const { show } = useToast();
  const { isFreePlan } = useUserPlan();

  const textTone = useMemo(() => {
    return isFreePlan ? 'subdued' : undefined;
  }, [isFreePlan]);
  const isSkip = useSelector(isSkipApiSelector);
  const isMobile = useMediaQuery({ maxWidth: BREAKPOINT.XS });
  const [updateGeneralSetting, { isLoading }] = apiCaller.useUpdateGeneralSettingMutation();
  const dataSettings = useSelector(dataSettingsSelector);
  const isLoadingSetting = useSelector(isLoadingGeneralSettingsSelector);

  const handleClick = async () => {
    if (isFreePlan) {
      navigate(PATH.PRICING_PLAN);
    } else {
      if (isSkip) return;
      try {
        const res = await updateGeneralSetting({ ...dataSettings, get_customer_zipcode: 1 }).unwrap();
        if (res.status === 'success') {
          show('Saved');
        }
      } catch (error) {}
    }
  };

  return (
    <Card>
      <div className="content-between align-center">
        <div className={`d-flex ${isMobile ? 'flex-column' : 'flex-row align-center'}`}>
          <div className="d-flex">
            <Icon tone={textTone} source={LocationIcon} />
            <div className="ml-8">
              <BoldText tone={textTone}>Auto-detect location</BoldText>
            </div>
          </div>
          {isFreePlan ? (
            <div style={{ marginLeft: isMobile ? '-8px' : 0, marginTop: isMobile ? '4px' : 0 }}>
              <BadgeWarning content="Upgrade" link={PATH.PRICING_PLAN} touchpoint={Touchpoint.ChecklistAutoDetectLocation} />
            </div>
          ) : dataSettings.get_customer_zipcode ? (
            <div className={`${isMobile} ? 'mt-4' : ml-8 `}>
              <Badge tone="success">On</Badge>
            </div>
          ) : null}
        </div>
        <div>
          {!dataSettings.get_customer_zipcode ? (
            isFreePlan ? null : (
              <Button onClick={handleClick} variant="primary" loading={isLoading || isLoadingSetting}>
                Turn on
              </Button>
            )
          ) : null}
        </div>
      </div>
      <div className="mt-8">
        <MediumText tone={textTone}>Automatically detect the zipcode/country of your site visitors.</MediumText>
      </div>
    </Card>
  );
}

export default memo(AutoDetectLocation);
